<template>
    <section class="kv">
        <div class="kv__content" data-aos="fade-up" data-aos-duration="1500">
            <img
                src="@/assets/images/kv__title.png"
                class="kv__title"
                alt="美肌榮耀"
                loading="lazy"
            />
            <img
                src="@/assets/images/kv__line.png"
                class="kv__line"
                alt="分隔線"
                loading="lazy"
            />
            <img
                src="@/assets/images/kv__subtitle.png"
                class="kv__subtitle"
                alt="千人募集2%水楊酸精華液，終結痘痘粉刺黑歷史"
                loading="lazy"
            />
        </div>
    </section>
</template>

<style lang="scss" scoped>
@import '@/styles/theKv';
</style>